import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../../helpers/loadingspinner";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import { Link } from "react-router-dom";
import {  CustomBenchsalesEmail, GetHotList,  GetJobRoles,PostHotList, SaveBenchsalesSubmissions} from "../../apiconstants/constants";
import { useCountry } from "../../contexts/countrycodecontext.js";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import WYSIWYGEditor from "../../helpers/WYSIWYGEditor.js";
import {Modal, Button } from 'react-bootstrap';

const ShareCandidateDetailstoSubvendor = () => {
  const { register, handleSubmit,watch, formState: { errors, isSubmitting }, control, reset,getValues, setValue } = useForm({
    defaultValues: {
      vendorGuid: [],
      vendorEmail: "",
      vendorName: "",
      jobPost: null,
      jobDescription: "",
      tierType: "Tier 1",
    }
  });
  const { register: registerModal, handleSubmit: handleSubmitModal, formState: { errors: modalErrors }, reset: resetModal } = useForm({
  defaultValues: {
    name: "",
    emailId: "",
    phone: "",
    company: "",
    website: "",  
    description: "",
     type: "Recruiter",   
    tierType: "Tier 1",

  }
});
   const navigate = useNavigate();
 
  const [isDisabled, setIsDisabled] = useState(false);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedCountry } = useCountry();
const [showPreview, setShowPreview] = useState(false);

  const userguid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const roleID = localStorage.getItem("roleID");
  const Guid = roleID == 3 ? employerGuid : userguid;
  const [pageCount, setPageCount] = useState(0);
  const fullName = localStorage.getItem("firstName");
const [tierFilter, setTierFilter] = useState('');
// const [subject, setSubject] = useState("");
const [benchSalesGuid, setBenchSalesGuid] = useState("");
const [candidateGuids, setCandidateGuids] = useState([]);
 const [searchTerm, setSearchTerm] = useState("");

  const handleTierFilterChange = (e) => {
  setTierFilter(e.target.value);
};
const [editingField, setEditingField] = useState({ index: null, field: null });
const [editedValue, setEditedValue] = useState("");
 const token = localStorage.getItem("jwtToken");
  const [subvendors, setSubvendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(8);
const email = localStorage.getItem("email")
const [jobRoles, setJobRoles] = useState([]);
const jobRoleOptions = jobRoles.map(role => ({
  value: role.jobRoleId,
  label: role.jobRole
}));
const [hasInitializedEmail, setHasInitializedEmail] = useState(false);
const [jobRoleAutoSelected, setJobRoleAutoSelected] = useState(false);

const [showAddModal, setShowAddModal] = useState(false);
   const [tier,setTier] = useState([
    {tierID:"Tier 1",tierName:"Tier 1"},
    {tierID:"Tier 2",tierName:"Tier 2"},
    {tierID:"Tier 3",tierName:"Tier 3"},
])
  const [type,settype] = useState([
    {statusID:"1",statusName:"Recruiter"},
    {statusID:"2",statusName:"BenchSales"}])

    const handleOpen = () => setShowAddModal(true);
const handleClose = () => setShowAddModal(false);

const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    };

   const fetchSubvendors = async () => {
      setLoading(true);
      try {
        const response = await Axios.get(
         `${GetHotList.APIURL}?UserGuid=${userguid}&countryId=${selectedCountry}`,
          {            headers: {  Authorization: `Bearer ${token}`
                                }          }  
        );
        const filteredRecruiters = response.data?.filter((x)=>x.type=='Recruiter'&& x.isActive == true)
        setSubvendors(filteredRecruiters);
         setPageCount(Math.ceil(filteredRecruiters?.length / itemsPerPage));
      } catch (error) {
        console.error('Error fetching subvendor data:', error);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    if (isAccordionOpen && Guid && selectedCountry) {
      fetchSubvendors();
    }
        fetchJobRoles();
  }, [isAccordionOpen, Guid, selectedCountry]);
const [selectedVendors, setSelectedVendors] = useState([]);
 const [selectAll, setSelectAll] = useState(false);

useEffect(() => {
  if (selectedVendors.length > 1) {
    setValue("ccEmail", "");
  }
}, [selectedVendors.length, setValue]);

  
const filteredSubvendors = subvendors.filter((v) => {
  const matchesTier = tierFilter ? v.tierType === tierFilter : true;
  const matchesSearch = `${v.name} ${v.emailId}`.toLowerCase().includes(searchTerm.toLowerCase());
  return matchesTier && matchesSearch;
});
  // Check if a vendor is selected
 const isVendorSelected = (vendorId) =>
  selectedVendors.some((v) => v.hotListID === vendorId);
// 🔥 Sort: selected vendors first, then unselected
const sortedSubvendors = [
  ...filteredSubvendors.filter(v => isVendorSelected(v.hotListID)),
  ...filteredSubvendors.filter(v => !isVendorSelected(v.hotListID))
];

// Slice for pagination
const offset = currentPage * itemsPerPage;
const currentPageVendors = sortedSubvendors.slice(offset, offset + itemsPerPage);

useEffect(() => {
  setPageCount(Math.ceil(sortedSubvendors.length / itemsPerPage));
}, [sortedSubvendors]);
const [showSelectedPanel, setShowSelectedPanel] = useState(false);
const removeSelectedVendor = (vendorId) => {
  const updated = selectedVendors.filter(v => v.hotListID !== vendorId);
  setSelectedVendors(updated);

  // Update Select All checkbox
  const allSelected =
    filteredSubvendors.length > 0 &&
    updated.length === filteredSubvendors.length;

  setSelectAll(allSelected);
};
  const safeValue = (val) => (val === "null" ||val === null || val === undefined ? "" : val);
const candidateMobileNumber = localStorage.getItem("mobileNumber");

const onSubmitStaffingContact = async (data) => {
  await AddData(data);
  resetModal(); // clears modal fields
  setShowAddModal(false);
};


const AddData = async (data) => {
  const params = {
    name: data.name,
    emailId: data.emailId,
    phone: data.phone,
    company: data.company,
    website: data.website,
    country: selectedCountry,
    type: data.type || 'Recruiter',
    tierType: data.tierType || "Tier 1",
    description: data.description,
    createdBy: email,
    userGuid: userguid,
    countryID: selectedCountry,
  };

  const apiUrl = PostHotList.APIURL;

  Axios.post(apiUrl, params,
     { headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
  )
    .then((result) => {
      if (result.data.message === "Inserted successfully.") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Added Successfully",
          showConfirmButton: false,
          timer: 5000,
        });
        
        // ✅ close modal instead of navigating away
        fetchSubvendors();
        setShowAddModal(false);

        // ✅ update table dynamically (optional)
        // fetchContacts(); 
      } else if (
        result.data.message === "duplicate Record  based on EmailId."
      ) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Staffing Contact exists!",
          showConfirmButton: false,
          timer: 5000,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Issue with data format!",
          showConfirmButton: false,
          timer: 5000,
        });
      }
    })
    .catch((error) => {
      console.log("Error", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "API Error!",
        text: error.message,
      });
    });
};

 const onSubmit = async (data, e) => {
  e.preventDefault();

  // ✅ Prepare vendors list
  const selectedVendorList = selectedVendors.map(v => ({
    recruiterGuid: v.guid,
    toEmail: v.emailId,
    recruiterName: v.name,
  }));

  if (selectedVendorList.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Please select at least one staffing contact to share.',
      showConfirmButton: true,
    });
    return;
  }

  setIsLoading(true);

  try {
    // ✅ Build candidate payload in API expected format
  // ✅ Build candidate payload for API
const candidatePayload = candidateData.map(c => ({
  candidateGuid: c.guid,
  billRate: c.billRate || ""  // ✅ use updated Payrate from state
}));


// ✅ Final payload
const payload = {
  fromEmail: data.clientemail,
  ccEmail: selectedVendors.length > 1 ? "" : data.ccEmail,
  fileUrls: [],
  content: data.content,
  jobRole: data.jobRole?.value?.toString(),
  subject: data.subject,
  phoneNumber: candidateMobileNumber,
  benchSalesGuid: benchSalesGuid,
  guid: userguid,
  recruiterGuid: selectedVendorList,
  candidateGuid: candidatePayload,
  shareType :data.shareType,
};

    console.log("🚀 Payload sent to API:", payload);

    const result = await Axios.post(CustomBenchsalesEmail.APIURL, payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (result.data === "Screening test reminder email sent.") {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Email sent Successfully",
        showConfirmButton: false,
        timer: 5000,
      });
       try {
        console.log("📨 Sending payload to savebenchsalessubmissions API...");
        const saveResult = await Axios.post(SaveBenchsalesSubmissions.APIURL, payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("✅ savebenchsalessubmissions API response:", saveResult.data);
      } catch (saveError) {
        console.error("❌ Error calling savebenchsalessubmissions API:", saveError);
      }
      localStorage.removeItem("selectedCandidateDetails");
      navigate("/Employer/InternalBench");
    } else if (
      result.data ===
      "Your User Type is  not Bench Sales . No emails sent or records inserted."
    ) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Your user type is not Bench Sales, so mail can't be sent!",
        showConfirmButton: false,
        timer: 5000,
      });
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Add correct Details",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  } catch (error) {
    console.log("Error sending email", error);
  } finally {
    setIsLoading(false);
  }
};


useEffect(() => {
  const selectedCandidates = JSON.parse(localStorage.getItem("selectedCandidateDetails")) || [];
  const loginUserGuid = localStorage.getItem("guid");

  setBenchSalesGuid(loginUserGuid);

  if (selectedCandidates) {
    try {
      const parsedData = selectedCandidates.map((candidate) => ({
        ...candidate,
        relocation: "Yes",
        // ✅ Normalize Payrate from either payRate or Payrate
        billrate: candidate.billRate || candidate.billRate || ""
      }));
          const sorted = parsedData.sort((a, b) => {
      const expA = parseFloat(String(a.experience)?.replace(/[^0-9.]/g, "")) || 0;
      const expB = parseFloat(String(b.experience)?.replace(/[^0-9.]/g, "")) || 0;
      return expB - expA;  // DESCENDING
    });
      setCandidateData(sorted);
       setCandidateGuids(sorted.map(c => ({ candidateGuid: c.guid })));
      // setCandidateGuids(selectedCandidates.map(c => ({ candidateGuid: c.guid })));
    } catch (e) {
      console.error("Error parsing candidate data from localStorage", e);
    }
  }
}, []);

useEffect(() => {
  if (candidateData.length === 0 || jobRoleOptions.length === 0) return;

  // ⭐ Prevent infinite loop: run once
  if (jobRoleAutoSelected) return;

  const uniqueRoles = [...new Set(candidateData.map(c => c.jobRoleName?.trim()))];

  if (uniqueRoles.length === 1 && uniqueRoles[0]) {
    const selectedOption = jobRoleOptions.find(
      opt => opt.label.toLowerCase() === uniqueRoles[0].toLowerCase()
    );

    if (selectedOption) {
      reset({
        ...getValues(),
        jobRole: selectedOption,
      });

      setJobRoleAutoSelected(true); // ⭐ important
    }
  }
}, [candidateData, jobRoleOptions]);





  // When "Select All" is toggled
  const handleSelectAll = (e) => {
  const checked = e.target.checked;
  setSelectAll(checked);

  if (checked) {
    // ✅ Select all from filtered list, not just paginated
    setSelectedVendors([...filteredSubvendors]);
  } else {
    // ❌ Clear all
    setSelectedVendors([]);
  }
};


const handleCheckboxChange = (vendor, checked) => {
  let updated;

  if (checked) {
    // Add this vendor if not already selected
    updated = [...selectedVendors, vendor];
  } else {
    // Remove this vendor
    updated = selectedVendors.filter(v => v.hotListID !== vendor.hotListID);
  }

  setSelectedVendors(updated);

  // Update "Select All" checkbox
  const allSelected =
    filteredSubvendors.length > 0 &&
    updated.length === filteredSubvendors.length;
  setSelectAll(allSelected);
};



 
    const fetchJobRoles = () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        Axios.get(getApiUrl).then((response) => {
            setJobRoles(response.data);
        }).catch((error) => {
            console.error("Error fetching job roles", error);
        });
    };



const editorContent = getValues("content");

const previewHtml = `
Hello ${selectedVendors[0]?.name},<br/>

Greetings from KnackHook!<br/>

I hope you are doing well.<br/>
  ${editorContent}

  <br/><br/>
  <strong>Best Regards,</strong><br/>
  <strong>KnackHook Bench Sales Team,</strong><br/>
  ✉️ <a href="mailto:${email}">${email},</a><br/>
  📞 ${candidateMobileNumber}<br/>
`;
  // Reset when subvendor list changes
  useEffect(() => {
    setSelectedVendors([]);
    setSelectAll(false);
  }, [subvendors]);

  

 const formatCandidateDetails = (candidate) => {
  const safe = (label, value) => {
    const clean = value?.toString().trim();
    return clean && clean !== "null" ? `${label}: ${clean}` : null;
  };

  const lines = [
    safe("Name", candidate.fullName?.split(" ")[0]),
    safe("Job Role", candidate.jobRoleName),
    safe("Experience", candidate.experience),
    safe("Location", candidate.location || candidate.preferredLocation),
    safe("Visa Status", candidate.workAuthorizationandValidity),
    safe("Availability", candidate.availability || "Immediate"),
   safe("Bill Rate", candidate.billRate), 
  ].filter(Boolean);

  return lines.length
    ? `${lines.join("<br/>")}`
    : "";
};
const jobRole = watch("jobRole");


useEffect(() => {
  if (!jobRole?.label || candidateData.length === 0) return;

  // ⭐ Prevent infinite loop — run only once
  if (hasInitializedEmail) return;

  const firstNames = candidateData
    .map((c) => safeValue(c.fullName)?.split(" ")[0])
    .filter(Boolean)
    .join(", ");

  const profileLabel = candidateData.length > 1 ? "Profiles" : "Profile";
  const resumeLabel = candidateData.length > 1 ? "resumes" : "resume";
  const defaultSubject = `${jobRole.label} - ${profileLabel} - ${firstNames}`;

  const formattedCandidates = candidateData
    .map(formatCandidateDetails)
    .filter(Boolean)
    .join("<br/><br/>");

  const defaultContent = `

This is ${fullName}, Sr. Bench Sales Recruiter at KnackHook. I’m reaching out to share the profile of a highly experienced consultant who is currently available for new opportunities. I’ve attached ${resumeLabel} for your review.<br/><br/>

Candidate Details: <br/><br/>
${formattedCandidates}<br/><br/>

Please let me know if you have any suitable openings or need further information.<br/>
Looking forward to hearing from you.
`;

  reset({
    ...getValues(),
    subject: defaultSubject,
    content: defaultContent,
  });

  setHasInitializedEmail(true); // ⭐ IMPORTANT — prevents re-running
}, [jobRole, candidateData]);


const startEditing = (index, field, currentValue) => {
  setEditingField({ index, field });
  setEditedValue(currentValue);
};


const saveFieldValue = (index, field) => {
  const updatedData = [...candidateData];
  updatedData[index][field] = editedValue;
  setCandidateData(updatedData);
  setEditingField({ index: null, field: null });
};

const handleKeyDown = (e, index, field) => {
  if (e.key === "Enter") {
    saveFieldValue(index, field);
  }
};

  return (
    <ConsultantLayout>
      <section>
        {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <div className="container-fluid mt-4 pb-5">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center flex-1">
                <Link to="/Employer/InternalBench">
                  <i className="fa fa-arrow-left me-2" style={{color: "#00a7ac", fontSize: 16 }} />
                </Link>
                <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px' }}>
   Share Candidate Details to Staffing Contact
  </h2>

              </div>
            </div>

            <hr />
         
  <div className="accordion" id="subvendorAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header"   >
          <button
            className={`accordion-button ${!isAccordionOpen ? 'collapsed' : ''}`}
            type="button"
            style={{ color: "#00a7ac" }}
            onClick={() => setIsAccordionOpen(prev => !prev)}
          >
            Staffing Contact Details
          </button>
        </h2>
        <div
          className={`accordion-collapse collapse ${isAccordionOpen ? 'show' : ''}`}
          aria-labelledby="headingOne"
        >
          <div className="accordion-body">
  {loading ? (
    <p>Loading staffing contacts...</p>
  ) : (
    <>
      {/* Search and Filter Row */}
    <div className="d-flex justify-content-between mb-3">

  {/* LEFT SIDE — Search */}
  <input
    type="text"
    className="form-control form-control-sm"
    style={{ width: "200px" }}
    placeholder="Search by name or email"
    value={searchTerm}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(0);
    }}
  />

  {/* RIGHT SIDE — Group everything together */}
  <div className="d-flex align-items-center gap-3">

    {/* Tier Filter */}
    <div className="d-flex align-items-center gap-1">
      <span style={{ fontSize: "12px" }}>Tier Type</span>
      <select
        value={tierFilter}
        onChange={handleTierFilterChange}
        className="form-select form-select-sm"
        style={{ width: "150px", fontSize: "12px", marginLeft: 5 }}
      >
        <option value="">All</option>
        <option value="Tier 1">Tier 1</option>
        <option value="Tier 2">Tier 2</option>
        <option value="Tier 3">Tier 3</option>
      </select>
    </div>

    {/* Eye Icon */}
    <button
      className="btn btn-primary"
      title="View Selected Staffing Contacts"
      onClick={() => {
         setShowSelectedPanel((prev) => !prev);
      }}
      > <i className="fa fa-eye"></i>
    </button>

    {/* Add Button */}
    <button className="btn btn-primary mr-3" onClick={handleOpen}>
      <i className="fa fa-plus"></i>
    </button>

  </div> {/* END RIGHT SIDE GROUP */}
</div>  {/* END FLEX ROW */}

{/* Selected Vendors Expandable Panel */}
{showSelectedPanel  && (
  <div className="p-2 mb-3 border rounded" style={{ background: '#f8f9fa' }}>
    <strong style={{ fontSize: '12px' }}>Selected Staffing Contacts:</strong>

    <div className="mt-2 d-flex flex-wrap" style={{ gap: '8px' }}>
      {selectedVendors.map(vendor => (
        <span
          key={vendor.hotListID}
         className="badge text-info d-flex align-items-center"
style={{
  backgroundColor: "#e9ecef",   // ✔ Bootstrap’s light gray
  border: "1px solid #d3d3d3",  // ✔ soft border
  padding: "6px 10px",
  fontSize: "11px",
  borderRadius: "20px"
}}

        >
          {vendor.name} — {vendor.emailId}
          <button
            className="btn btn-sm ms-2 p-0 bg-transparent border-0"
            style={{ cursor: 'pointer', color: '#000' }}
            onClick={() => removeSelectedVendor(vendor.hotListID)}
          >
         <i className="fa fa-times"></i>

          </button>
        </span>
      ))}
    </div>
  </div>
)}
      {/* Table */}
      <table
        className="table"
        style={{
          minWidth: "100%",
          fontSize: "12px",
          marginBottom: "12px",
          wordWrap: "break-word",
        }}
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Company</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Tier Type</th>
            <th>
              Actions
                <span className="ms-2">
                Select All
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  title="Select All"
                  style={{ marginLeft: 5 }}
                />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {currentPageVendors.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No staffing contacts found.
              </td>
            </tr>
          ) : (
            currentPageVendors.map((vendor, index) => (
              <tr key={vendor?.id || index}>
                <td>{vendor.name || '-'}</td>
                <td>{vendor.company || '-'}</td>
                <td>{vendor.emailId || '-'}</td>
                <td>{vendor.phone || '-'}</td>
                <td>{vendor.tierType || '-'}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={isVendorSelected(vendor.hotListID)}
                    onChange={(e) => handleCheckboxChange(vendor, e.target.checked)}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {currentPageVendors.length > 0 && (
        <div className="mt-3">
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        </div>
      )}
    </>
  )}
</div>
        </div>
      </div>
    </div>


            <div className="card shadow-lg mt-5 p-5 border-0">
              <form onSubmit={handleSubmit(onSubmit)}>
             
                <div className="invalid-feedback">{errors.vendorGuid?.message}</div>
{/* Share Type */}
<div
  className="mt-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
  }}
>
  {/* Left Label */}
  <label
    style={{
      color: "#00a7ac",
      marginBottom: 0,
      fontWeight: 500,
      minWidth: 110,
    }}
  >
    Share Type
  </label>

  {/* Radio Buttons */}
  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <input
        type="radio"
        id="hotlistShare"
        value="Hotlist Share"
        {...register("shareType", { required: "Please select share type" })}
        style={{
          transform: "scale(0.85)", // 🔹 smaller radio
          cursor: "pointer",
        }}
      />
      <label htmlFor="hotlistShare" style={{ marginBottom: 0 }}>
        Hotlist Share
      </label>
    </div>

    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <input
        type="radio"
        id="apply"
        value="Initial Share"
        {...register("shareType", { required: "Please select share type" })}
        style={{
          transform: "scale(0.85)", // 🔹 smaller radio
          cursor: "pointer",
        }}
      />
      <label htmlFor="apply" style={{ marginBottom: 0 }}>
        Apply
      </label>
    </div>
  </div>
</div>




{errors.shareType && (
  <span className="text-danger d-block mt-1">
    {errors.shareType.message}
  </span>
)}



                <OverlayTrigger
                 placement="bottom"
                 overlay={(props) => (
                   <Tooltip id="tooltip" {...props}>From Email</Tooltip>
                 )}
               >
                 <input
                   type="email"
                   {...register("clientemail", { required: "From Email is required" })}
                   placeholder="From Email"
                   defaultValue={email}
                   className={`form-control basic-form mt-3 ${errors.clientemail ? 'is-invalid' : ''}` }
                 />
               </OverlayTrigger>

{selectedVendors.length < 2 && (
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>
        CC Email
      </Tooltip>
    )}
  >
    <input
      type="email"
      {...register("ccEmail")}
      placeholder="CC Email"
      className="form-control basic-form mt-3"
    />
  </OverlayTrigger>
)}


                {/* Candidate Table */}
             
              <div>
              <div className="mt-3">
 <Controller
      name="jobRole"
      control={control}
      rules={{ required: "Job Role Required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobRoleOptions}
          placeholder="Select Job Role"
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          styles={{
            control: (base, state) => ({
              ...base,
              height: 50,
              borderRadius: 15,
              fontSize: 12,
              borderColor: errors.jobRole ? "red" : base.borderColor,
            }),
             menuPortal: base => ({ ...base, zIndex: 9999 }) // ⬅️ very important
          }}
        />
      )}
    />

    {errors.jobRole && (
      <span className="text-danger">{errors.jobRole.message}</span>
    )}
  </div>
            </div>
              <div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Subject</Tooltip>)}>
                <input type="text" title='' placeholder='Subject' {...register("subject", { required: "Subject Required" })} id="subject" name="subject"
                  disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.subject ? 'is-invalid' : ''}`}
                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.subject?.message}</div>
            </div>
            <div>
              <label style={{ color: "#00a7ac", marginTop: 10 }}>Content</label>
              <Controller
                control={control}
                name="content"
                rules={{
                  required: { value: true, message: "Content Required" },
                }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <div>
                    <WYSIWYGEditor
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                      inputExtraProps={{
                        required: true,
                      }}
                    />
                    {errors.content && (
                      <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                        {errors.content.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          <div className="col-12 mt-4" style={{ overflowX: "auto", width: "100%" }}>
                    <label style={{ color: "#00a7ac", marginTop: 10 }}>Candidates Information</label>
                  <table className="table table-bordered" style={{ fontSize: "12px" }}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Job Role</th>
                        <th>Current Visa & First US Entry</th>
                        <th>Relocation</th>
                        <th>Experience</th>
                        <th>Bill Rate</th> 
                      </tr>
                    </thead>
                   <tbody>
  {candidateData.map((data, index) => (
    <tr key={index}>
      {/* Full Name */}
      <td>
       

        {editingField.index === index && editingField.field === "fullName" ? (
  <input
    value={editedValue}
    autoFocus
    onChange={(e) => setEditedValue(e.target.value)}
    onBlur={() => saveFieldValue(index, "fullName")}
    onKeyDown={(e) => handleKeyDown(e, index, "fullName")}
  />
) : (
  <>
    {safeValue(data.fullName)?.split(" ")[0]} {/* Only first name */}
    &nbsp;
    <span
      onClick={() =>
        startEditing(index, "fullName", safeValue(data.fullName)?.split(" ")[0]) // ✏️ Pass only first name
      }
      style={{ cursor: "pointer", color: "gray" }}
    >
      ✏️
    </span>
  </>
)}

      </td>

      {/* Job Role */}
      <td>
        {editingField.index === index && editingField.field === "jobRoleName" ? (
          <input
            value={editedValue}
            autoFocus
            onChange={(e) => setEditedValue(e.target.value)}
            onBlur={() => saveFieldValue(index, "jobRoleName")}
            onKeyDown={(e) => handleKeyDown(e, index, "jobRoleName")}
          />
        ) : (
          <>
            {safeValue(data.jobRoleName)}
            &nbsp;
            <span
              onClick={() =>
                startEditing(index, "jobRoleName", safeValue(data.jobRoleName))
              }
              style={{ cursor: "pointer", color: "gray" }}
            >
              ✏️
            </span>
          </>
        )}
      </td>

      {/* Work Auth */}
      <td>
        {editingField.index === index &&
        editingField.field === "workAuthorizationandValidity" ? (
          <input
            value={editedValue}
            autoFocus
            onChange={(e) => setEditedValue(e.target.value)}
            onBlur={() =>
              saveFieldValue(index, "workAuthorizationandValidity")
            }
            onKeyDown={(e) =>
              handleKeyDown(e, index, "workAuthorizationandValidity")
            }
          />
        ) : (
          <>
            {safeValue(data.workAuthorizationandValidity)}
            &nbsp;
            <span
              onClick={() =>
                startEditing(
                  index,
                  "workAuthorizationandValidity",
                  safeValue(data.workAuthorizationandValidity)
                )
              }
              style={{ cursor: "pointer", color: "gray" }}
            >
              ✏️
            </span>
          </>
        )}
      </td>

    <td>
{editingField.index === index && editingField.field === "relocation" ? (
  <input
    value={editedValue}
    autoFocus
    onChange={(e) => setEditedValue(e.target.value)}
    onBlur={() => saveFieldValue(index, "relocation")}
    onKeyDown={(e) => handleKeyDown(e, index, "relocation")}
  />
) : (
  <>
    {safeValue(data.relocation) || "Yes"} {/* Show Yes if null */}
    &nbsp;
    <span
      onClick={() =>
        startEditing(index, "relocation", safeValue(data.relocation) || "Yes")
      }
      style={{ cursor: "pointer", color: "gray" }}
    >
      ✏️
    </span>
  </>
)}

</td>
      {/* Experience */}
      <td>
        {editingField.index === index && editingField.field === "experience" ? (
          <input
            value={editedValue}
            autoFocus
            onChange={(e) => setEditedValue(e.target.value)}
            onBlur={() => saveFieldValue(index, "experience")}
            onKeyDown={(e) => handleKeyDown(e, index, "experience")}
          />
        ) : (
          <>
            {safeValue(data.experience)}
            &nbsp;
            <span
              onClick={() =>
                startEditing(index, "experience", safeValue(data.experience))
              }
              style={{ cursor: "pointer", color: "gray" }}
            >
              ✏️
            </span>
          </>
        )}
      </td>
 {/* Pay Rate */}
     <td>
  {editingField.index === index && editingField.field === "billRate" ? (
    <input
      value={editedValue}
      autoFocus
      onChange={(e) => setEditedValue(e.target.value)}
      onBlur={() => saveFieldValue(index, "billRate")}
      onKeyDown={(e) => handleKeyDown(e, index, "billRate")}
    />
  ) : (
    <>
      {safeValue(data.billRate)}
      &nbsp;
      <span
        onClick={() =>
          startEditing(index, "billRate", safeValue(data.billRate))
        }
        style={{ cursor: "pointer", color: "gray" }}
      >
        ✏️
      </span>
    </>
  )}
</td>

    
    </tr>
  ))}
</tbody>

                  </table>
                </div>

                <div className="row mb-4 mt-3">
                  <div className="col-12 text-end">
                      <button type="button" disabled={isSubmitting || isDisabled} className="btn btn-primary mr-2"
 onClick={() => setShowPreview(prev => !prev)} // 🔁 Toggle logic
>
  {showPreview ? '✖ Close Preview' : '📄 Preview Email'}
</button>
                    
                    <button type="submit" disabled={isSubmitting || isDisabled} className="btn btn-primary mr-2">
                      {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
                      Share
                    </button>
              <Link to="/Employer/InternalBench">
                      <button type="button" disabled={isSubmitting || isDisabled} className="btn btn-secondary me-2">
                        Cancel
                      </button>
                    </Link>

                  </div>
                </div>
              </form>
                     {showPreview && (
  <div className="mt-4 p-4 border rounded bg-light"  style={{  backgroundColor: 'transparent',fontSize: '12px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
    <h5>Email Preview</h5>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>
)}

            </div>
          </div>
        )}
 <Modal show={showAddModal} onHide={handleClose} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#00a7ac" }}>Add Staffing Contact</Modal.Title>
  </Modal.Header>

  <Modal.Body>
<form onSubmit={handleSubmitModal(onSubmitStaffingContact)}>
        <div className="row">
        {/* Left Column */}
        <div className="col-md-6">
          {/* Name */}
          <OverlayTrigger
            placement="bottom"
            overlay={(props) => <Tooltip id="tooltip" {...props}>Name</Tooltip>}
          >
            <input
              type="text"
              name="name"
              {...registerModal("name", { required: "Name Required" })}
              placeholder="Name"
              className={`form-control basic-form mt-3 ${
                modalErrors.name ? "is-invalid" : ""
              }`}
            />
          </OverlayTrigger>
          <div className="invalid-feedback">{modalErrors.name?.message}</div>

          {/* Email */}
          <input
            type="email"
            name="emailId"
            {...registerModal("emailId", { required: "Email Required" })}
            placeholder="Email"
 className={`form-control basic-form mt-3 ${
                modalErrors.emailId ? "is-invalid" : ""
              }`}          />
          <div className="invalid-feedback">{modalErrors.emailId?.message}</div>

          {/* Website */}
          <input
            type="text"
            name="website"
            {...registerModal("website")}
            placeholder="Website URL"
            className="form-control basic-form mt-3"
          />

          {/* Tier */}
          <select
            {...registerModal("tierType")}
            className="form-control basic-form mt-3"
          >
            <option value="">Select Tier</option>
            {tier.map((item, index) => (
              <option key={index} value={item.tierName}>
                {item.tierName}
              </option>
            ))}
          </select>
        </div>

        {/* Right Column */}
        <div className="col-md-6">
          {/* Phone */}
          <input
            type="text"
            name="phone"
            placeholder="Mobile Number"
            {...registerModal("phone")}
            className={`form-control basic-form mt-3`}
          />

          {/* Company */}
          <input
            type="text"
            name="company"
            {...registerModal("company")}
            placeholder="Company Name"
            className="form-control basic-form mt-3"
          />

          {/* Description */}
          <textarea
            name="description"
            {...registerModal("description")}
            placeholder="Description"
            className="form-control basic-form mt-3"
          />

          {/* Type */}
          <select
            {...registerModal("type")}
            className={`form-control basic-form mt-3`}
          >
            <option value="">Select Type</option>
            {type.map((item, index) => (
              <option key={index} value={item.statusName}>
                {item.statusName}
              </option>
            ))}
          </select>
        </div>
      </div>
    </form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleClose}>
      Cancel
    </Button>
  <Button
  type="submit"
  variant="primary"
  onClick={handleSubmitModal(onSubmitStaffingContact)}
  disabled={isSubmitting}
>
  {isSubmitting && (
    <span className="spinner-border spinner-border-sm me-1"></span>
  )}
  Save
</Button>

  </Modal.Footer>
</Modal>


      </section>
    </ConsultantLayout>
  );
};

export default ShareCandidateDetailstoSubvendor;
